import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/romance', label: '恋爱' },
  { path: '/category/fantasy', label: '奇幻' },
  { path: '/category/action', label: '动作' },
  { path: '/category/suspense', label: '悬疑' },
  { path: '/category/comedy', label: '搞笑' },
];

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0 min-w-0">
            <span
              className={`font-heading text-xl md:text-2xl whitespace-nowrap leading-none transition-colors duration-300 ${
                scrolled ? 'text-primary-600' : 'text-white drop-shadow-md'
              }`}
            >
              基德漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'text-foreground-600 hover:text-foreground-900'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <Link
              to="/category/romance"
              className="px-5 py-2 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled
                ? 'text-foreground-700 hover:bg-background-200/70'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200/70'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="border-t border-background-200/70 my-2"></div>
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm text-foreground-600 hover:bg-background-200/70 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
            <Link
              to="/category/romance"
              className="px-4 py-3 bg-primary-500 text-white rounded-full text-sm font-medium text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}